import { render, staticRenderFns } from "./zhiShiGouJian.vue?vue&type=template&id=639bee85&scoped=true&"
import script from "./zhiShiGouJian.vue?vue&type=script&lang=js&"
export * from "./zhiShiGouJian.vue?vue&type=script&lang=js&"
import style0 from "./zhiShiGouJian.vue?vue&type=style&index=0&id=639bee85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639bee85",
  null
  
)

export default component.exports